import api from './axiosService';

export const productApi = {
    
    // PRODUCT TYPES
    getProductTypes(params = {}) {
        return api.get('/product-types', { params });
    },

    getActiveProductTypes() {
        return api.get('/product-types/active');
    },

    getProductTypeById(productTypeId) {
        return api.get(`/product-types/${productTypeId}`);
    },

    createProductType(data) {
        return api.post('/product-types', data);
    },

    updateProductType(productTypeId, data) {
        return api.put(`/product-types/${productTypeId}`, data);
    },

    toggleProductTypeStatus(productTypeId) {
        return api.patch(`/product-types/${productTypeId}/toggle-status`);
    },

    // PRODUCT CATEGORIES
    getProductCategories(params = {}) {
        return api.get('/product-categories', { params });
    },

    getActiveProductCategories() {
        return api.get('/product-categories/active');
    },

    getProductCategoriesByProductType(productTypeId) {
        return api.get(`/product-categories/by-product-type/${productTypeId}`);
    },

    getProductCategoryById(productCategoryId) {
        return api.get(`/product-categories/${productCategoryId}`);
    },

    createProductCategory(data) {
        return api.post('/product-categories', data);
    },

    updateProductCategory(productCategoryId, data) {
        return api.put(`/product-categories/${productCategoryId}`, data);
    },

    toggleProductCategoryStatus(productCategoryId) {
        return api.patch(`/product-categories/${productCategoryId}/toggle-status`);
    },

    // PRODUCTS
    getProducts(params = {}) {
        return api.get('/products', { params });
    },

    getActiveProducts() {
        return api.get('/products/active');
    },

    getProductById(productId) {
        return api.get(`/products/${productId}`);
    },

    getProductByCategory(productCategoryId) {
        return api.get(`/products/by-category/${productCategoryId}`);
    },

    getPackageTypes() {
        return api.get('/products/package-types');
    },

    createProduct(data) {
        return api.post('/products', data);
    },

    updateProduct(productId, data) {
        return api.put(`/products/${productId}`, data);
    },

    toggleProductStatus(productId) {
        return api.patch(`/products/${productId}/toggle-status`);
    },
};